import { render } from "./TheModernFooter.vue?vue&type=template&id=2b95dc9c&scoped=true&ts=true"
import script from "./TheModernFooter.vue?vue&type=script&lang=ts"
export * from "./TheModernFooter.vue?vue&type=script&lang=ts"

import "./TheModernFooter.vue?vue&type=style&index=0&id=2b95dc9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b95dc9c"]])

export default __exports__